import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { MailRibbonControlId } from 'owa-ribbon-ids';
import type { RibbonControlId } from 'owa-ribbon-ids';
import type { RibbonControlDefinitionProps } from 'owa-mail-ribbon-utils';
import * as ControlDef from './mlrViewTabControlDefinitions';

/**
 * This function supplies a mapping from MailRibbonControlId to their respective control definition function.
 * For any new control in a tab, be sure to update the mapping below.
 * Note: This function should *not* have any logic regarding showing/hiding.
 *       That should be in shouldShowRibbonControl.ts instead.
 */
export const getMLRViewTabControlDefinition = computedFn(
    (controlId: RibbonControlId, props: RibbonControlDefinitionProps): RibbonControlProps => {
        switch (controlId) {
            case MailRibbonControlId.ImmersiveReader:
                return ControlDef.getImmersiveReaderControl();
            case MailRibbonControlId.Print:
                return ControlDef.getPrintControl();
            default:
                throw new Error(
                    'Unknown control: ' +
                        controlId +
                        ' searched for in getMLRViewTabControlDefinition'
                );
        }
    }
);
